import React from 'react';
import PropTypes from 'prop-types';
import { classList } from 'utils/componentsCommon';

const Spacer = ({ size = '', ...props }) => {
    const classNames = classList(size && `size-${size}`);

    return <hr className={ classNames } { ...props } />;
};

Spacer.propTypes = {
    size: PropTypes.string,
};

export default Spacer;
